module.exports = __webpack_public_path__ + "img/ore.a393a1ef.png";